module.exports = __webpack_public_path__ + "static/media/luma-banner-50.3b10bb25.png";